import axios from 'components/Axios';
import { commonsearch } from '../APIEndPoint';

const getSearchUsersList = (payload) => {
  const promise = axios.get(
    `${commonsearch}/users?keyword=${encodeURIComponent(payload?.keyword)}&page=${
      payload?.page || 0
    }&size=${payload?.size || 20}`
  );
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const getSearchJobList = (payload) => {
  const promise = axios.get(
    `${commonsearch}/jobs?keyword=${encodeURIComponent(payload?.keyword)}&page=${
      payload?.page || 0
    }&size=${payload?.size || 6}`
  );
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

export {
  getSearchUsersList,
  getSearchJobList,
};
